import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]

  connect() {
    this.timeout = null
    this.saving = false
  }

  // Debounced submit for text inputs
  change(event) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.submit()
    }, 1000) // Wait 1 second after typing stops
  }

  // Immediate submit for selects/checkboxes
  submit() {
    if (this.saving) return

    this.saving = true
    this.showSaving()

    const form = this.element
    const formData = new FormData(form)

    fetch(form.action, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Accept": "application/json"
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      this.showSaved()
      this.saving = false
    })
    .catch(error => {
      this.showError()
      this.saving = false
      console.error("Save failed:", error)
    })
  }

  showSaving() {
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = '<i class="fas fa-spinner fa-spin text-blue-600"></i> Saving...'
      this.statusTarget.classList.remove("hidden")
    }
  }

  showSaved() {
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = '<i class="fas fa-check-circle text-green-600"></i> Saved'
      this.statusTarget.classList.remove("hidden")

      // Hide after 2 seconds
      setTimeout(() => {
        this.statusTarget.classList.add("hidden")
      }, 2000)
    }
  }

  showError() {
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = '<i class="fas fa-exclamation-circle text-red-600"></i> Save failed'
      this.statusTarget.classList.remove("hidden")

      // Hide after 3 seconds
      setTimeout(() => {
        this.statusTarget.classList.add("hidden")
      }, 3000)
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
